import React, { Fragment } from 'react';
import { Row, Col, Progress } from 'reactstrap';
import Icofont from 'react-icofont';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './Tdsaboutslider.css';
import KS from '../services/KensoftApi';
import parse from 'html-react-parser';

class Tdsaboutslider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AboutProducts: [],
      ChooseUs: [],
    };
  }
  componentDidMount() {
    KS.getAboutProducts({
      id: 20036,
      langid: 1,
    }).then((data) => {
      if (data.Success) {
        this.setState({
          AboutProducts: data.AboutProducts,
        });
      }
    });
    KS.getChooseUs({
      id: 20037,
      langid: 1,
    }).then((data) => {
      if (data.Success) {
        this.setState({
          ChooseUs: data.ChooseUs,
        });
      }
    });
  }
  render() {
    return (
      <OwlCarousel
        className="owl-theme"
        loop
        margin={10}
        nav={false}
        items="1"
        dots={true}
        lazyLoad={true}
      >
        <div className="item">
          <div className="title-box mb-0 text-left">
            <h2 className="mb-0">
              About <b>al-Jawhara CO.</b>
            </h2>
            <h4 className="mt-0 mb-2 sub-title">
              {' '}
              <span>Our Products are : </span>
            </h4>
          </div>
          {this.state.AboutProducts.map((item) => {
            return (
              <Fragment>
                <Row>
                  <Col className="text-left">
                    <h6 className="mb-0">{item.Name} </h6>
                  </Col>
                  <Col className="text-right">
                    <h6 className="mb-0">{parse(item.Description)}</h6>
                  </Col>
                </Row>
                <Progress
                  value={parseFloat(parse(item.Description))}
                  animated
                  color="orange"
                  className="mb-3"
                />
              </Fragment>
            );
          })}
        </div>

        <div className="item">
          <div className="title-box text-left mb-0">
            <h2 className="mb-0">
              Know About Our <b>Mission</b>
            </h2>
          </div>
          <p>
            One of the goals of our company is to produce high quality products
            in large quantities to meet the requirements of the markets while
            maintaining the highest health and international standards.
          </p>
        </div>

        <div className="item">
          <div className="title-box text-left mb-0">
            <h2 className="mb-0">
              Why Choose <b>Us</b>
            </h2>
            <p>Our products are chosen by the consumer due to the</p>
          </div>
          <div className="why-choose">
            <Row noGutters>
              {this.state.ChooseUs.map((item) => {
                return (
                  <Col xs="6" sm="6" md="4">
                    <div className="why-box text-center">
                      <Icofont icon={item.Description} />
                      <h5>{item.Name}</h5>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
      </OwlCarousel>
    );
  }
}

export default Tdsaboutslider;
